"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _fileTypeIconMap = _interopRequireDefault(require("../../../../../common/constants/fileTypeIconMap")),
    _fileTypes = require("../../../../../common/constants/fileTypes"),
    _Upload = _interopRequireDefault(require("../../Upload")),
    _FileTypeIcon = _interopRequireDefault(require("../../FileTypeIcon"));

require("../styles/_image-preview.scss");

function getImageUrl(a, b) {
  return a ? null : b ? "".concat(b, "#").concat(Date.now()) : b;
}

function ImagePreview(a) {
  var b = a.asset,
      c = a.imageProps,
      d = void 0 === c ? {} : c,
      e = a.hideFileTypeIcon,
      f = a.type,
      g = a.darkMode,
      h = b || {},
      i = h.uploadStatus,
      j = h.loadedPercent,
      k = (0, _lodash["default"])(b, "assetFiles", {}),
      l = k.THUMBNAIL || k.ORIGINAL || {},
      m = l.sourceUrl,
      n = f === _fileTypes.VIDEO,
      o = f === _fileTypes.HEIC;
  return _react["default"].createElement("div", {
    className: "image-preview"
  }, _react["default"].createElement(_uiKit.Image, (0, _extends2["default"])({
    imageUrl: getImageUrl(o, m),
    width: "100%",
    height: "100%",
    backgroundSize: "contain",
    defaultImageIcon: n ? "projects" : _fileTypeIconMap["default"][f],
    defaultIconSize: o ? 50 : void 0,
    defaultIconBackground: g ? "black" : "catSkillWhite",
    defaultIconColour: g ? "michael" : "black"
  }, d)), m && !e ? _react["default"].createElement(_FileTypeIcon["default"], {
    className: "image-preview__media-icon",
    name: n ? "projects" : "image",
    color: "white"
  }) : null, _react["default"].createElement(_Upload["default"], {
    loadedPercent: j,
    uploadStatus: i
  }));
}

var _default = (0, _react.memo)(ImagePreview);

exports["default"] = _default;